module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/hero_mob-321ad1dd3c0577f3c9c13d88b7e63f96.jpg";